<div class="merge-tag-node" [attr.data-depth]="node.depth">
	<div
		class="merge-tag-node__row"
		[class.merge-tag-node__row--leaf]="node.isLeaf"
		[style.paddingLeft.px]="node.depth * 14"
		(click)="onContainerClick()"
	>
		<button
			type="button"
			class="merge-tag-node__expander"
			*ngIf="node.children?.length"
			(click)="onToggle($event)"
			attr.aria-label="Toggle {{ node.label }}"
		>
			<mat-icon>{{ expanded ? 'expand_more' : 'chevron_right' }}</mat-icon>
		</button>

		<div class="merge-tag-node__content">
			<div class="merge-tag-node__label" [innerHTML]="node.highlightedLabel || node.label"></div>
			<div class="merge-tag-node__meta" *ngIf="node.displayPath">
				<!-- <span class="merge-tag-node__path" [innerHTML]="node.highlightedPath || node.displayPath"></span> -->
				<span class="merge-tag-node__example" *ngIf="showExample && node.exampleValue">{{ node.exampleValue }}</span>
			</div>
		</div>
	</div>

	<div class="merge-tag-node__children" *ngIf="expanded && node.children?.length">
		<app-merge-tag-tree-node
			*ngFor="let child of node.children; trackBy: trackByPath"
			[node]="child"
			[expanded]="childExpanded(child.path)"
			[expandedPaths]="expandedPaths"
			[showExample]="showExample"
			(toggle)="toggle.emit($event)"
			(select)="select.emit($event)"
		></app-merge-tag-tree-node>
	</div>
</div>
